export default __webpack_public_path__ + "static/media/Headdress of the Amaranthine Drums.63f5c917.jpg";